<div class="flex justify-content-center">
    <!-- <button pButton pRipple type="button" icon="pi pi-file" label="Import Clients" class="text-sm p-button-outlined mr-3"></button> -->
    <button pButton pRipple type="button" icon="pi pi-plus" label="Create Prospects" class="text-sm p-button-outlined"  (click)="OpenPopup()"></button>
 </div>
 <create-prospect  *ngIf="showCreateProspectPopup | async as showPopup" [visible]="showPopup"
(hidePopup)="hidePopup($event)"></create-prospect>
